export const profile = {
  title: 'Profil',
  oldPassword: 'Stare hasło',
  newPassword: 'Nowe hasło',
  repeatNewPassword: 'Powtórz nowe hasło',
  firstName: 'Imię',
  lastName: 'Nazwisko',
  email: 'Email',
  authenticator: 'Aplikacja autoryzacyjna',
  role: 'Rola',
  fieldRequired: 'To pole jest wymagane',
  passwordRules: {
    minLength: 'Minimum {min} znaków',
    uppercase: 'Minimum jedna wielka litera (A-Z)',
    lowercase: 'Minimum jedna mała litera (a-z)',
    number: 'Minimum jedna cyfra (0-9)',
    specialCharacter: 'Minimum jeden znak specjalny ({characters})',
  },
  passwordStrength: {
    title: 'Siła hasła',
    subTitle: 'Sprawdź spełnione wymagania',
    power: {
      weak: 'Słabe',
      medium: 'Średnie',
      strong: 'Silne',
    },
  },
  updateSuccess: 'Profil został zaktualizowany pomyślnie',
  passwordUpdateSuccess: 'Hasło zostało zaktualizowane pomyślnie',
  add2FAModalTitle: 'Dodaj metodę 2FA',
  insertPassword: 'Podaj hasło',
  insertAuthenticatorCode: 'Podaj kod z aplikacji uwierzytelniającej',
  updatedDefault2FAMethod: 'Domyślna metoda 2FA została zaktualizowana',
  confirmDelete2FAModalTitle: 'Potwierdź usunięcie metody 2FA',
  successDeleted2FAModal: 'Metoda 2FA została pomyślnie usunięta',
  successAdd2FAMethod: 'Dodano metodę uwierzytelniającą.',
  confirmChangePasswordTitle: 'Potwierdź zmianę hasła',
}
